import {
  Typography,
  Box,
  styled,
  TextField,
  Button,
  FormHelperText,
  Backdrop,
  CircularProgress,
  Divider,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const HelpAndSupport = () => {
  return (
    <>
      <Box className="heading">
        <Typography component="h1">HELP & SUPPORT</Typography>
      </Box>
      <Box className="hs_content">
        <Box className="banner">
          <Box className="banner-content">
            <Typography component="h1">How can we help you?</Typography>
            <Typography component="p">
              We’re here to assist you with any inquiries or concerns. Our team
              is ready to provide support and guidance.
            </Typography>
          </Box>
        </Box>

        <Box className="qa-div">
          <Box className="qa">
            <Typography component="h1">
              How can I upload a goal video?
            </Typography>
            <Typography component="p">
              Navigate to the "Upload" section from the main menu, fill out the
              required details, and submit your video. Ensure it meets the
              length and quality guidelines.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">How do I vote for videos?</Typography>
            <Typography component="p">
              Simply click the "Vote" button on the video you like. You will
              need to confirm your mobile number and email to receive your free
              votes.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">What are the voting rules?</Typography>
            <Typography component="p">
              You can vote for a video once every 24 hours. Use all your votes
              on one video or spread them out among different videos.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">How do tournaments work?</Typography>
            <Typography component="p">
              Users can participate in ongoing tournaments by uploading videos
              and voting for others. Monthly and yearly leaderboards will
              determine the winners, who will receive cash prizes.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">
              What happens at the end of the month?
            </Typography>
            <Typography component="p">
              At the end of each month, the voting for that month's tournament
              closes, and the leaderboard is refreshed. Videos will move to the
              worldwide leaderboard for year-long voting.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">
              Can I share videos with others?
            </Typography>
            <Typography component="p">
              Yes! You can share goal videos you like through social media
              platforms or messaging apps directly from the video page.
            </Typography>
          </Box>
          <Divider sx={{ borderColor: "#414466" }} />

          <Box className="qa">
            <Typography component="h1">
              How can I contact support if I have issues?
            </Typography>
            <Typography component="p">
              For support, please contact us via email at
              <span style={{ color: "#FFCD1F", cursor: "pointer" }}>
                {" "}
                mynetgoals01@gmail.com
              </span>
              . We are here to help!
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HelpAndSupport;
